import apiClient from '@/api/index'
import { PROJECT_PREFIX } from "@/constants/projects";

export const profileModule = {
    namespaced: true,

    state:() => ({
        userdata: {}
    }),

    mutations: {
        setProfileData(state, data) {
            state.userdata = data
        },
    },

    actions: {
        getUserData({ commit }) {
            apiClient.get(PROJECT_PREFIX.tcode + "/profile/", {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                console.log(response.data);
                commit('setProfileData', response.data)
            })
            .catch((error) => {
                console.log(error.response);
            });
        }
    }
}